import { StateType } from '../../../../state/reducers';

export const getPathFormated = (
  path: Array<string>,
  searchType: StateType['queryParams']['type'],
) => {
  const dataKeys = [
    'aggregation_name',
    'category',
    'sub_category',
    'sub_sub_category',
  ];
  const reducer = (
    acc: { [s: string]: string },
    key: string,
    index: number,
  ) => ({
    ...acc,
    [dataKeys[index]]: key,
  });
  return path.reduce(reducer, {
    search_type: searchType,
  });
};
